import { ID, SortContext } from "./types";

export function arrayShift(ctx: SortContext, newOrderPosition: number): ID[] {
  "worklet";

  // First, find and remove index from order array
  const newOrder = ctx.order.value.filter(
    (orderId) => orderId !== ctx.droppedId
  );

  // Then, insert index at position specified by newIndex
  newOrder.splice(newOrderPosition, 0, ctx.droppedId);

  return newOrder;
}

export function arrayUnchanged(
  ctx: SortContext,
  newOrderPosition: number
): ID[] {
  return ctx.order.value;
}
